import TablePagination, {
	TablePaginationProps,
} from "@mui/material/TablePagination";
import { FC } from "react";

export type InvoicesPaginationProps = Pick<
	TablePaginationProps,
	| "count"
	| "page"
	| "onPageChange"
	| "onRowsPerPageChange"
	| "rowsPerPage"
	| "rowsPerPageOptions"
>;

export const InvoicesPagination: FC<InvoicesPaginationProps> = ({
	count,
	page,
	onPageChange,
	onRowsPerPageChange,
	rowsPerPage = 5,
	rowsPerPageOptions = [5, 10, 20],
}) => {
	return (
		<TablePagination
			component="div"
			count={count}
			onPageChange={onPageChange}
			onRowsPerPageChange={onRowsPerPageChange}
			page={page}
			rowsPerPage={rowsPerPage}
			rowsPerPageOptions={rowsPerPageOptions}
		/>
	);
};
